import { Injectable } from '@angular/core';
import { Api } from '../api/api';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/share';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';

/*
  Generated class for the GlobalNotificationsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GlobalNotificationsProvider {
  private hasNewMessage = new BehaviorSubject<boolean>(false);
  newMessage = this.hasNewMessage.asObservable();

  private hasNewContactRequest = new BehaviorSubject<boolean>(false);
  newContactRequest = this.hasNewContactRequest.asObservable();

  private picksRemaining = new BehaviorSubject<number>(0);
  picksRemainingCount = this.picksRemaining.asObservable();

  constructor(private api: Api) {}

  showNewMessageIndicator(show: boolean) {
    this.hasNewMessage.next(show);
  }

  showNewContactRequestIndicator(show: boolean) {
    this.hasNewContactRequest.next(show);
  }

  checkNewMessages(): Observable<any> {
    return this.api.post('info/check', {}).map(res => {
      return res;
    });
  }

  retrieveNewMessages(): Observable<any> {
    return this.api.post('messages/check', {}).map(res => {
      return res;
    });
  }

  notificationActions(message: string): void {
    switch (message) {
      case 'NEW_MESSAGE':
        this.showNewMessageIndicator(true);
        //this.retrieveNewMessages().subscribe();
        break;
      case 'FRIEND_REQUEST':
        this.showNewContactRequestIndicator(true);
        break;
      case 'NEW_CONTACT':
        break;
      default:
        break;
    }
  }

  setPicksRemainingCount(count: number) {
    this.picksRemaining.next(count);
  }

  getRemainingPicks(userId): Observable<any> {
    return this.api
      .post('user/getRemainingFavorites', { uuid: userId })
      .map(res => {
        return res;
      });
  }

  getPicksCount() {
    return this.picksRemaining.getValue();
  }

  checkUserVisibility(eventId): void {}
}



// WEBPACK FOOTER //
// ./src/providers/global-notifications/global-notifications.ts